module.exports = __webpack_public_path__ + "static/img-4.c3dc5241.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/office_img/img-4.jpg
// module id = 900
// module chunks = 41802369688294